module.exports = __webpack_public_path__ + "img/4.4c96aef8.jpg";